<script setup>
/**
 * @fileoverview Header call to action: book a free design consultation to
 * order the current design. Opens in a new tab so the design stays open.
 *
 * @component
 */
import { useMosaicStore } from '../stores/mosaicStore';
import { CONSULTATION_URL } from '../utils/handOff.js';
import { trackConsultationClick } from '../utils/trackingService';
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline';

const store = useMosaicStore();
</script>

<template>
    <a
        :href="CONSULTATION_URL"
        target="_blank"
        rel="noopener"
        class="inline-flex items-center gap-2 text-dryline text-medium lg:text-2xl font-bold font-header tracking-tight leading-snug underline underline-offset-4 decoration-1 hover:no-underline"
        data-testid="consultation-link"
        @click="trackConsultationClick(store.selectedPatternId, store.paintedCount)"
    >
        Schedule a call to order this custom mosaic today!
        <ArrowTopRightOnSquareIcon class="w-4 h-4 lg:w-5 lg:h-5 shrink-0" aria-hidden="true" />
        <span class="sr-only">(opens in a new tab)</span>
    </a>
</template>
